import { createUseStyles } from 'react-jss'

import { colors } from '../../../variables.style'

export const style = {
  formulaButton: {
    '&:hover, &:focus': {
      '& $formulaIcon': {
        color: colors.brandAccent
      }
    }
  },
  formulaIcon: {
    color: 'white',
    fontSize: 20,
    marginTop: -2
  },
  formulaContainer: {
    width: 500,
    marginTop: 30,
    marginBottom: 30
  }
}

export const useStyles = createUseStyles(style)
